const styles = {
  wizardContainer: {
    width: '100%',
    height: '100%',
    background: '#fff',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    justifyContent: 'space-between',
    padding: 0,
    minHeight: 0,
  },
  contentArea: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '40px 32px',
    minWidth: 0,
    minHeight: 0,
    maxHeight: '70vh',
    overflowY: 'auto',
  },
  stepIndicators: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 16,
    padding: '32px 16px',
    background: 'transparent',
    minWidth: 48,
    height: '100%',
  },
  activeStep: {
    color: '#1976d2',
    fontSize: 22,
    fontWeight: 'bold',
    transition: 'color 0.2s',
  },
  inactiveStep: {
    color: '#bdbdbd',
    fontSize: 22,
    transition: 'color 0.2s',
  },
  stepTitle: {
    fontSize: 20,
    fontWeight: 600,
    margin: 0,
    textAlign: 'center',
    marginBottom: 24,
  },
  stepContent: {
    fontSize: 16,
    color: '#333',
    minHeight: 60,
    minWidth: 400,
    textAlign: 'center',
    marginBottom: 12,
  },
};

export default styles;
